/* eslint-disable react/jsx-props-no-spreading */
import React, { useMemo } from 'react';
import { animated } from '@react-spring/web';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import tinycolor from 'tinycolor2';

import * as AppPropTypes from '../../lib/PropTypes';
import Html from '../partials/Html';
import Image from '../partials/Image';

import styles from '../../../styles/cards/year.module.scss';

const propTypes = {
    item: AppPropTypes.card.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const YearCard = ({ item, className }) => {
    const { description, year = null, image = null, alt, yearColor, backgroundColor } = item || {};
    const descriptionColor = useMemo(
        () => (backgroundColor !== null && tinycolor(backgroundColor).isDark() ? '#FFF' : '#000'),
        [backgroundColor],
    );

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            {image !== null ? (
                <animated.div className={styles.imageContainer}>
                    <Image
                        className={styles.image}
                        media={image}
                        alt={alt}
                        fit="contain"
                        size="small"
                    />
                </animated.div>
            ) : null}
            <div className={styles.inner} style={{ backgroundColor }}>
                <animated.div className={styles.content}>
                    <div className={styles.elements}>
                        <div className={styles.top}>
                            {year !== null ? (
                                <div className={styles.year} style={{ color: yearColor }}>
                                    {year}
                                </div>
                            ) : null}
                        </div>
                        <div style={{ color: descriptionColor }}>
                            <Html className={styles.description} body={description} />
                        </div>
                    </div>
                </animated.div>
            </div>
        </div>
    );
};

YearCard.propTypes = propTypes;
YearCard.defaultProps = defaultProps;

export default YearCard;
